import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonToggleGroup, MatButtonToggle } from '@angular/material/button-toggle';
import { SelectEmployeeComponent } from '../selections/select-employee/select-employee.component';
import { MatFormField, MatLabel, MatSelect, MatSelectTrigger, MatOption } from '@angular/material/select';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';

@Component({
    selector: 'app-global-filter',
    templateUrl: './global-filter.component.html',
    styleUrls: ['./global-filter.component.scss'],
    imports: [MatButtonToggleGroup, MatButtonToggle, SelectEmployeeComponent, MatFormField, MatLabel, MatSelect, FormsModule, ReactiveFormsModule, NgxIntlTelInputModule, MatSelectTrigger, MatOption]
})
export class GlobalFilterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  toppings = new UntypedFormControl();

  toppingList: string[] = ['Extra cheese', 'Mushroom', 'Onion', 'Pepperoni', 'Sausage', 'Tomato'];

  employeeSelectionChanged(event){
    console.log("Employee selection changed event received", event)
  }

}
